<template>
  <router-link :to="route" class="sell-and-rent-row">
    <div class="cell">
      <h5>{{ user.name || '-' }}</h5>
    </div>
    <div class="cell">
      <p>{{ user.phone_number || '-' }}</p>
    </div>
    <div class="cell">
      <p>{{ sourceLabel }}</p>
    </div>
    <div class="cell">
      <h5>{{ home.address_number || '-' }}</h5>
    </div>
    <div class="cell wrap">
      <p>{{ home.project.name || '-' }}</p>
    </div>
    <div class="cell">
      <p>{{ home.plot_code || '-' }}</p>
    </div>
    <div class="cell wrap">
      <p>{{ home.address_line || '-' }}</p>
    </div>
    <div class="cell currency">
      <p>{{ home.usable_area || '-' }}</p>
    </div>
    <div class="cell currency">
      <p>{{ home.sell_price | commas("-") }}</p>
    </div>
    <div class="cell currency">
      <p>{{ home.rent_price | commas("-") }}</p>
    </div>
    <div class="cell">
      <h5>{{ created_at | date }}</h5>
    </div>
    <div class="cell">
      <h5>{{ updated_by.first_name || '-' }}</h5>
    </div>
    <div class="cell wrap">
      <h5 class="current-status" :class="css">{{ status || '-' }}</h5>
    </div>
  </router-link>
</template>

<script>
/* eslint-disable vue/prop-name-casing */
import Vue from "vue"
import { SellAndRentSource } from "../SellAndRentSource";

export default Vue.extend({
  props: {
    user: {
      type: null,
      default: undefined,
    },
    home: {
      type: null,
      default: undefined,
    },
    created_at: {
      type: null,
      default: undefined,
    },
    status: {
      type: null,
      default: undefined,
    },
    updated_by: {
      type: null,
      default: undefined,
    },
    route: {
      type: null,
      default: undefined,
    },
    source: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {}
  },
  computed: {
    css() {
      return { completed: this.isCompleted }
    },
    sourceLabel() {
      return SellAndRentSource[this.source] || '-';
    }
  },
})
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.sell-and-rent-row {
  display: grid;
  // MUST stay identical to .row-header in SellAndRentListPage.vue so columns align.
  grid-template-columns: 150px 120px 150px 100px 160px 100px 180px 120px 130px 130px 130px 130px 170px;
  width: max-content;
  min-width: 100%;
  grid-gap: 15px;
  align-items: center;

  // left padding aligns the first column with the filters; right stays full-bleed
  padding: ($space / 3) 0 ($space / 3) $space;

  // the whole row is an <a>; never underline its text
  text-decoration: none;

  &:hover {
    background: #fafafa;
    cursor: pointer;
    color: $secondary-color;

    // <p> cells carry an explicit dark color at rest, so unlike the <h5> cells
    // they don't follow the link's hover color. Make them inherit it on hover
    // so every column's text turns blue together.
    > .cell > p {
      color: inherit;
    }
  }
}

.sell-and-rent-row > .cell {
  white-space: nowrap;

  // columns allowed to wrap onto multiple lines (โครงการ / ที่อยู่ / สถานะ)
  &.wrap {
    white-space: normal;
    overflow-wrap: break-word;
  }

  > h5 {
    font-size: 16px;
  }

  > p {
    font-size: 14px;
  }

  > h5,
  > p {
    line-height: 1.6;
    margin: 0;
  }

  &.currency > p {
    margin-right: 30px;
    text-align: right;
  }
}

.current-status {
  &.completed {
    color: $success-color;
  }
}
</style>
